import { useSelector } from 'react-redux';
import type { SelectOption, SetState } from '../../../../../../../types';
import FilterCardCheckboxes from '../../../../../../generic/Filter/FilterCardCheckboxes';
import { DependencyInfoOptions } from '../../../../ReportGeneration/utils';
import { isFeatureEnabled } from '../../../../../../../helpers/features';
import { FILE_PATH_IN_REPORTS } from '../../../../../../../../shared/featureFlags/flagNames';
import * as reportGeneration from '../../../../../../../redux/reportGeneration';

type Props = {
  values: SelectOption[];
  setValues: SetState<SelectOption[]>;
};

const DependencyMetadataCheckboxGroup = ({ values, setValues }: Props) => {
  const isFilePathInReports = isFeatureEnabled(FILE_PATH_IN_REPORTS);
  const projectType = useSelector(reportGeneration.selectors.getProjectType);
  const options = Object.entries(DependencyInfoOptions)
    .filter(([key]) => {
      if (key === 'FilePath') {
        return isFilePathInReports;
      }
      if (key === 'Project') {
        return projectType === 'releaseGroup';
      }

      return true;
    })
    .map(([key, value]) => ({ label: value, value: key }));
  return (
    <div className="width-full" data-test-id="sbom-filters-dependency-metadata">
      <FilterCardCheckboxes label="Dependency Metadata" options={options} values={values} onChange={setValues} />
    </div>
  );
};

export default DependencyMetadataCheckboxGroup;
